<div *ngIf="this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.pgaAftrekbareGiften &&
            Object.keys(this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.pgaAftrekbareGiften || {}).length > 0;">

    <form [formGroup]="specGiftenFormGroup">
        <div formGroupName="specificatieGiften">
            <div formGroupName="opbouw">
                <div *ngIf="specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'gewoneGiften'])?.value > 0">
                    <div class="row">
                        <div class="col col-1">
                            <p>Gewone giften</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="gewoneGiften"
                                    id="gewoneGiften"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-2"></div>
                    </div>
                    <div *ngIf="specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'gewoneGiftenCultureel'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Gewone giften cultureel</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="gewoneGiftenCultureel"
                                        id="gewoneGiftenCultureel"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2"></div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                    <div *ngIf="specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'verhogingGewoneCultureleGiften'])?.value > 0">
                        <div class="row">
                            <div *ngIf="specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'verhogingGewoneCultureleGiften'])?.value !== 1250 && specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'verhogingGewoneCultureleGiften'])?.value !== 2500"
                                 class="col col-1">
                                <p>Verhoging gewone giften cultureel</p>
                            </div>
                            <div *ngIf="specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'verhogingGewoneCultureleGiften'])?.value === 1250 || specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'verhogingGewoneCultureleGiften'])?.value === 2500"
                                 class="col col-1">
                                <p>Verhoging gewone giften cultureel (maximaal)</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="verhogingGewoneCultureleGiften"
                                        id="verhogingGewoneCultureleGiften"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2"></div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                    <div *ngIf="specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'drempelGiften'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Af: Drempel gewone giften</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="drempelGiften"
                                        id="drempelGiften"
                                        prefix="€ - "
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2"></div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="row">
                        <div *ngIf="!this.giftenMaxOpbvInkomen" class="col col-1">
                            <p>Aftrekbare gewone giften</p>
                        </div>
                        <div *ngIf="this.giftenMaxOpbvInkomen" class="col col-1">
                            <p>Aftrekbare gewone giften (max. 10% van drempelinkomen) </p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="aftrekbareGewoneGiften"
                                    id="aftrekbareGewoneGiften"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-2"></div>
                    </div>
                </div>
                <div
                        *ngIf="specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'periodiekeGiften'])?.value > 0">
                    <div class="row">
                        <div class="col col-1">
                            <p>Periodieke giften</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="periodiekeGiften"
                                    id="periodiekeGiften"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-2"></div>
                    </div>
                </div>
                <div
                        *ngIf="specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'periodiekeGiftenCultureel'])?.value > 0">
                    <div class="row">
                        <div class="col col-1">
                            <p>Periodieke giften cultureel</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="periodiekeGiftenCultureel"
                                    id="periodiekeGiftenCultureel"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-2"></div>
                    </div>
                </div>
                <div
                        *ngIf="specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'verhogingPeriodiekeCultureleGiften'])?.value > 0">
                    <div class="row">
                        <div *ngIf="specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'verhogingPeriodiekeCultureleGiften'])?.value === 1250 || specGiftenFormGroup.get(['specificatieGiften', 'opbouw', 'verhogingPeriodiekeCultureleGiften'])?.value === 2500"
                             class="col col-1">
                            <p>Verhoging periodieke giften cultureel (maximum)</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="verhogingPeriodiekeCultureleGiften"
                                    id="verhogingPeriodiekeCultureleGiften"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-2"></div>
                    </div>
                </div>
                <div>
                    <div class="row">
                        <div class="col col-1">
                            <p><b>Aftrekbare giften</b></p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="totaalGiftenaftrek"
                                    id="totaalGiftenaftrek"
                                    placeholder="-"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

